export default __webpack_public_path__ + "static/media/slide-8.11ae6aee.jpeg";